export const API_BASE = process.env.CONTRACTORS_API;
export const API_PATH = 'contractors';
export const COSTS_API_PATH = `${API_PATH}/costs`;
export const COUNTRIES_API_PATH = 'common/supported-countries';
